import api from './api';

export interface Product {
  id: number;
  name: string;
  code: string;
  category?: string;
  description?: string;
  isActive: boolean;
}

export interface CreateProductRequest {
  name: string;
  code: string;
  category?: string;
  description?: string;
}

export interface UpdateProductRequest extends CreateProductRequest {
  isActive: boolean;
}

export const productService = {
  getAll: () => api.get<Product[]>('/products'),
  
  getById: (id: number) => api.get<Product>(`/products/${id}`),
  
  search: (search: string = '', limit: number = 20) =>
    api.get<Product[]>(`/products/search?search=${encodeURIComponent(search)}&limit=${limit}`),
  
  create: (data: CreateProductRequest) =>
    api.post<Product>('/products', data),
  
  update: (id: number, data: UpdateProductRequest) =>
    api.put<Product>(`/products/${id}`, data),
  
  delete: (id: number) =>
    api.delete(`/products/${id}`),
};
